import { Portal, Tooltip as ChakraTooltip } from '@chakra-ui/react';
import type { TooltipProps } from '@/components/ui/lib/tooltip-types';

export type { TooltipProps };

export const Tooltip = ({
  ref,
  content,
  children,
  contentProps,
  portalled = true,
  portalRef,
  showArrow = false,
  disabled = false,
  ...rest
}: TooltipProps) => {
  if (disabled) {
    return <>{children}</>;
  }

  return (
    <ChakraTooltip.Root {...rest}>
      <ChakraTooltip.Trigger asChild>{children}</ChakraTooltip.Trigger>
      <Portal disabled={!portalled} container={portalRef}>
        <ChakraTooltip.Positioner>
          <ChakraTooltip.Content ref={ref} {...contentProps}>
            {showArrow && (
              <ChakraTooltip.Arrow>
                <ChakraTooltip.ArrowTip />
              </ChakraTooltip.Arrow>
            )}
            {content}
          </ChakraTooltip.Content>
        </ChakraTooltip.Positioner>
      </Portal>
    </ChakraTooltip.Root>
  );
};
